'use client';

import React from 'react';
import Link from 'next/link';
// Image import removed - using inline SVG

export default function Footer() {
  const year = 2026;

  return (
    <footer
      className="border-t mt-20"
      style={{ borderColor: 'var(--border)', background: 'var(--secondary)' }}>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://assets.pippa.io/shows/5f8e56cfe2dbd533ea999829/1768695759339-fd46b5b0-818a-4bcd-8deb-d995b76f3c1f.jpeg"
                  alt="True Hauntings podcast show art"
                  width={32}
                  height={32}
                  style={{ borderRadius: '6px', objectFit: 'cover', width: '32px', height: '32px' }} />
                
              </div>
              <span style={{ fontFamily: 'var(--font-display)', color: 'var(--foreground)', fontWeight: 700, fontSize: '0.9rem' }}>
                True Hauntings
              </span>
            </div>
            <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)', maxWidth: '260px' }}>
              Australia's premier paranormal podcast. Anne & Renata investigate the world's most haunted places, cursed locations, and chilling ghost stories.
            </p>
            <p className="text-xs mt-4" style={{ color: 'var(--muted-foreground)', fontFamily: 'var(--font-mono)' }}>
              © {year} Frightfully Good Productions
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xs font-bold tracking-widest uppercase mb-4" style={{ color: 'var(--primary)', fontFamily: 'var(--font-mono)' }}>
              Navigate
            </h3>
            <ul className="space-y-2">
              {[
              { label: 'Home', href: '/' },
              { label: 'Episodes', href: '/episodes' },
              { label: 'About', href: '/about' },
              { label: 'Contact', href: '/contact' }]?.
              map((link) =>
              <li key={link?.href}>
                  <Link
                  href={link?.href}
                  className="text-xs transition-colors"
                  style={{ color: 'var(--muted-foreground)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--primary)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'var(--muted-foreground)'}>
                  
                    {link?.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Listen */}
          <div>
            <h3 className="text-xs font-bold tracking-widest uppercase mb-4" style={{ color: 'var(--primary)', fontFamily: 'var(--font-mono)' }}>
              Listen & Follow
            </h3>
            <ul className="space-y-2">
              {[
              { label: 'Spotify', href: 'https://open.spotify.com/show/1FIfOIC08D6v9Y5FP6ud1c' },
              { label: 'Apple Podcasts', href: 'https://podcasts.apple.com/au/podcast/true-hauntings/id1537052147' },
              { label: 'YouTube', href: 'https://www.youtube.com/@FrightfullyGoodAnneAndRenata' },
              { label: 'Patreon', href: 'https://www.patreon.com/c/anneandrenata' },
              { label: 'Instagram', href: 'https://www.instagram.com/anneandrenata/' },
              { label: 'Facebook', href: 'https://www.facebook.com/TrueHauntingsPodcast/' }]?.
              map((link) =>
              <li key={link?.href}>
                  <a
                  href={link?.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs transition-colors"
                  style={{ color: 'var(--muted-foreground)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--primary)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'var(--muted-foreground)'}>
                  
                    {link?.label}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-3" style={{ borderColor: 'var(--border)' }}>
          <p className="text-xs" style={{ color: 'var(--muted-foreground)', fontFamily: 'var(--font-mono)' }}>
            Hosted on Acast · New episodes every 2 weeks
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.ghostgrannies.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs transition-colors"
              style={{ color: 'var(--muted-foreground)' }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'var(--primary)'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'var(--muted-foreground)'}>
              
              ghostgrannies.com
            </a>
            <Link
              href="/admin"
              className="text-xs transition-colors"
              style={{ color: 'var(--muted-foreground)' }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'var(--primary)'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'var(--muted-foreground)'}>
              
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>);

}